<template>
  <PullRefresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
    <div :class="`${$style.pageWrapper}`">
      <img :class="$style.pageBack" :src="pageIcon" />
      <div :class="$style.pageBox">
        <div :class="`${$style.pageContent}`">
          <h2 :class="$style.placeTitle">在玩游戏会场</h2>
          <div v-if="playGames && playGames.length > 0" :class="$style.gameList">
            <div
              v-for="game in playGames"
              :key="game.gameId"
              :class="$style.gameBox"
              @click="onSkipDetail({ ...game, isPlay: 1 })"
            >
              <img :src="game.gameIcon" alt="游戏图片" :class="$style.gameImg" />
              <div :class="$style.gameSection">
                <div :class="$style.gameTitle">{{ game.gameName }}</div>
                <div :class="$style.gameDesc">价值{{ game.giftValue }}元礼包</div>
              </div>
            </div>
          </div>
          <div v-else :class="$style.empty">
            <p>暂无在玩游戏～</p>
            <p>请查看下方<span>【更多游戏会场】</span>，</p>
            <p>选择自己喜欢的游戏下载参与活动吧！</p>
          </div>
        </div>
      </div>
      <div :class="$style.pageBox">
        <div :class="`${$style.pageContent}`">
          <h2 :class="$style.placeTitle">更多游戏会场</h2>
          <div v-if="moreGames && moreGames.length > 0" :class="$style.gameList">
            <div
              v-for="game in moreGames"
              :key="game.gameId"
              :class="$style.gameBox"
              @click="onSkipDetail({ ...game, isPlay: 2 })"
            >
              <img :src="game.gameIcon" alt="游戏图片" :class="$style.gameImg" />
              <div :class="$style.gameSection">
                <div :class="$style.gameTitle">{{ game.gameName }}</div>
                <div :class="$style.gameDesc">价值{{ game.giftValue }}元礼包</div>
              </div>
            </div>
          </div>
          <div v-else :class="$style.empty">
            <p>暂无更多游戏～</p>
          </div>
        </div>
      </div>
    </div>
  </PullRefresh>
</template>

<script>
import { inithandler } from "@/bridge/jsBridge";
import { CDN_URL_1 } from "@/config";
import { burnPoint } from "@/apis/heziShare";
import {
  onGoBack,
  setPageTitle,
  getUserInfo,
  signInEventTrack,
  toLogin,
  setRightTxt,
  clickRightTxt,
  setRightTxtColor,
} from "@/bridge/AppJsBridge";
import { weekGiftPlacesApi } from "@/apis/wxActivity";
import { PullRefresh } from "vant";
import { getCookie } from "@/libs/utils";
import { queue } from "../../../libs/queue.request";

export default {
  name: "",
  components: {
    PullRefresh,
  },
  data() {
    return {
      cdnLink: CDN_URL_1,
      pageTitle: "礼包周周领",
      pageIcon: null,
      activityId: "",
      hiddenTitle: false,
      cookie: null,
      isLoading: false,
      moreGames: [],
      playGames: [],
      reqQueue: queue(),
    };
  },
  computed: {},

  created() {
    // 页面初始化
    inithandler();
    this.reqQueue.create();
    this.initPageData();
    try {
      signInEventTrack((data) => {
        this.cookie = JSON.parse(data);
      });
    } catch (error) {
      // 错误处理
    }
  },
  activated() {
    setRightTxt("");
  },
  watch: {
    cookie(value, oldValue) {
      if (!oldValue && value && !getCookie()) {
        this.reqQueue.run(value);
      }
    },
  },
  mounted() {},
  methods: {
    // 下拉刷新
    async onRefresh() {
      await this.initPageData();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    // 数据上报
    eventTrack(data) {
      // this.$toast(data.event)
      const params = {
        ...data,
      };
      if (!this.cookie) {
        console.log("数据上报异常", data.event, "转为补充数据上报");
        this.reqQueue.add(burnPoint, params);
        return;
      }
      console.log("正常数据上报", data.event);
      burnPoint({
        ...this.cookie,
        ...params,
      }).catch((err) => console.log(err));
    },
    // 获取cookie、缓存等携带的用户信息数据
    async initPageData() {
      const pageCookie = getCookie();
      if (pageCookie) {
        for (const key in pageCookie) {
          if (
            Object.hasOwnProperty.call(pageCookie, key) &&
            pageCookie[key] === "null"
          ) {
            delete pageCookie[key];
          }
        }
        this.cookie = pageCookie;
      }
      // 获取token
      this.getAppToken();
    },
    // 获取登录态
    getAppToken() {
      if (getCookie("token")) {
        localStorage.setItem("token", getCookie("token"));
        this.getActPlaceData();
      } else {
        getUserInfo((userInfo) => {
          let Info = JSON.parse(userInfo);
          if (Info.token) {
            localStorage.setItem("token", Info.token);
          }
          this.getActPlaceData();
        });
      }
    },
    getActPlaceData() {
      weekGiftPlacesApi()
        .then((res) => {
          const { data } = res;
          this.playGames = data.playGameVoList;
          this.moreGames = data.moreGameVoList;
          this.pageTitle = data.name;
          setPageTitle(data.name);
          this.pageIcon = data.icon;
          this.activityId = data.activityId;
          this.eventTrack({
            event: "weekly_act_main_place_page",
            event_field: JSON.stringify({ act_name: this.pageTitle }),
          });
        })
        .catch((error) => {
          let errorInfo = error.response;
          const { data } = errorInfo;
          if (data && data.code === 401) {
            toLogin("/loginKey/LoginByKeyPhoneActivity");
          }
        });
    },

    // 跳转游戏活动页面
    async onSkipDetail({ activityGameId, activityId, gameId, gameName, isPlay }) {
      this.eventTrack({
        event: "weekly_act_main_place_enter",
        event_field: JSON.stringify({
          act_name: this.pageTitle,
          type: isPlay,
        }),
        appName: gameName,
        appkey: gameId,
      });
      this.$router.push({
        name: `box.wxWeekGiftActivityDetail`,
        query: { activityId, activityGameId, title: this.pageTitle, type: isPlay, isFirstEnter: false },
      });
    },

    // 关闭页面
    closePage() {
      onGoBack();
    },

  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>
.pageWrapper {
  width: 100%;
  min-height: 100vh;
  max-width: 375px;
  margin: auto;
  background: #fbe5bd;
  background-size: 100% 100%;
  overflow: auto;
  position: relative;

  .pageBack {
    width: 100%;
    top: 0px;
    position: absolute;
  }
  .pageBox {
    background-color: #fdd37b;
    width: 90%;
    margin: 0 auto 10px;
    border: 4px solid #fdd37b;
    border-radius: 4px;
    overflow-y: auto;
    z-index: 2;
    position: relative;
    top: 302px;
  }
  &.hiddenTitle {
    padding-top: 0px;
    > header {
      display: none;
    }
    .download {
      top: 0px;
    }
  }
  > header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    max-width: 375px;
    margin: auto;
    z-index: 3;
    background: #ffffff;
    color: #000000;
    font-size: 19px;
    padding: 14px 5px 14px 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      font-weight: bold;
      position: absolute;
    }
    > span {
      font-size: 18px;
      font-weight: 700;
      margin: 0 auto;
    }
    :global {
      .iconfont {
        font-size: 22px;
        margin-right: 5px;
      }
    }
  }
  .pageContent {
    padding: 11.34px 10.36px 10.65px;
    background: #f6f6f6;
    border-radius: 4px;
    overflow-y: auto;
    // box-shadow: 1px 1px 3px 1px rgba(185, 31, 8, 0.64),
    //   1px 1px 0px 1px rgba(255, 255, 255, 0.75) inset,
    //   0px 0px 0.61px 0px rgba(255, 77, 77, 0.83) inset;
    .placeTitle {
      font-size: 18px;
      font-weight: 700;
      text-align: left;
      color: #333333;
      line-height: 20px;
      margin-bottom: 10px;
    }
    .empty {
      color: #666666;
      font-size: 14px;
      font-weight: 400;
      text-align: center;
      > p {
        line-height: 24px;
        > span {
          color: #fc5f5e;
        }
      }
    }
    .gameList {
      display: flex;
      flex-wrap: wrap;
    }
    .gameBox {
      width: 47%;
      display: flex;
      justify-content: left;
      align-items: center;
      margin-bottom: 6px;
      margin-left: 9px;
      .gameImg {
        width: 45px;
        height: 45px;
        margin-right: 5px;
      }
      .gameTitle {
        font-size: 14px;
        font-weight: 700;
        text-align: left;
        color: #666666;
        line-height: 14px;
      }
      .gameDesc {
        font-size: 12px;
        font-weight: 500;
        text-align: left;
        color: #ff7a2a;
        line-height: 12px;
        margin-top: 9px;
      }
    }
  }
}
</style>
